import Vue from "vue";
import VueRouter from "vue-router";
import Cookies from "js-cookie";
import Login from "./views/Login";
import SinochemLogin from "./views/sinochem/Login";
import SinochemFormLogin from "./views/sinochem/FormLogin";
import WorkFlowList from "./views/workFlow/List";
import PushSwitch from "./views/PushSwitch";
import ServiceFee from "./views/ServiceFee";
import ReceiptPlanDetail from "./views/ReceiptPlanDetail";
import Thread from "./views/Thread";
import ThreadPool from "./views/ThreadPool";
import ThreadDetails from "./views/ThreadDetails";
import redAndTransfer from "./views/wechat/redPacketTransfer/RedAndTransfer";
import Transfer from "./views/Transfer";
import Forms from "./views/Forms";
import Success from "./views/Success";
import Equipment from "./views/Equipment";
import WorkflowPosition from "./views/WorkflowPosition";
import Customer from "./views/Customer";
import OrderDetail from "./views/OrderDetail";
import Tab from "./views/Tab";
import TabDetails from "./views/TabDetails";
import SaleChance from "./views/SaleChance";
import SaleChanceDetails from "./views/SaleChanceDetails";
import Project from "./views/Project";
import ProjectDetails from "./views/ProjectDetails";
import QrCodeProjectDetails from "./views/QrCodeProjectDetails";
import SignUp from "./views/SignUp";
import ActivityDetail from "./views/ActivityDetail";
import Form from "./components/Form";
import TableGrid from "./components/TableGrid";
import userInfo from "./store/userInfo";
import "./assets/styles.css";
import checkPermission from "./mixin/checkPermission";
import OrderSummary from "./views/OrderSummary";
import WechatBind from "./views/wechat/Bind";
import { NavBar } from "vant";
import App from "./views/App";
import Test from "./views/Test";
import ActivityList from "./views/marketActivity/ActivityList";
import ActivityDetails from "./views/marketActivity/ActivityDetails";
import MyCustomer from "./views/marketActivity/MyCustomer";
import CustomerDetail from "./views/marketActivity/CustomerDetail";
import EleContract from "./views/EleContract";
import Map from "./views/Map";
import Rad from "./views/rad/Index";
import Input from "./views/rad/Input";
import InputDetail from "./views/rad/InputDetail";
import Output from "./views/rad/Output";
import OutputDetails from "./views/rad/OutputDetails";
import ReceiptOut from "./views/rad/ReceiptOut";
import ReceiptOutDetails from "./views/rad/ReceiptOutDetails";
import CancelStatus from "./views/rad/CancelStatus";
import StockTaking from "./views/rad/StockTaking";
import StockTakingDetail from "./views/rad/StockTakingDetail";
import StockTakingResult from "./views/rad/StockTakingResult";
import ScanningOutput from "./views/rad/ScanningOutput";
import PositionChange from "./views/rad/PositionChange";
import Freight from "./views/customized/guohuanhuanbao/Freight";
import FreightDetail from "./views/customized/guohuanhuanbao/FreightDetail";
import DealerOrder from "./views/rad/DealerOrder";
import RadOrder from "./views/rad/RadOrder";
import QualityInspection from "./views/rad/QualityInspection";
import BomList from "./views/rad/BomList";
import BomDetailList from "./views/rad/BomDetailList";
import RadOrderAudit from "./views/rad/RadOrderAudit";
import RadOrderDetail from "./views/rad/RadOrderDetail";
import OrderSku from "./views/rad/OrderSku";
import RadSku from "./views/rad/RadSku";
import OrderSkuDetail from "./views/rad/OrderSkuDetail";
import RadSkuDetail from "./views/rad/RadSkuDetail";
import SkuCart from "./views/rad/SkuCart";
import RadCart from "./views/rad/RadSkuCart";
import RadDealerRank from "./views/rad/RadDealerRank";
import RadDealerRankOrder from "./views/rad/RadDealerRankOrder";
import RadRankOrderDetail from "./views/rad/RadRankOrderDetail";
import InvIndex from "./views/rad/InvIndex";
import SkuInventory from "./views/rad/SkuInventory";
import PartsInventory from "./views/rad/PartsInventory";
import SearchSkuDetail from "./views/rad/SearchSkuDetail";
import ElectronicErpInput from "./views/electronicErp/Input";
import ElectronicErpInventoryBalance from "./views/electronicErp/inventoryBalance";
import ElectronicErpInventoryBalanceDetail from "./views/electronicErp/inventoryBalanceDetail";
import ElectronicErpStockTaking from "./views/electronicErp/stockTaking";
import ElectronicErpStockTakingCategory from "./views/electronicErp/stockTakingCategory";
import ElectronicErpStockTakingCategorySku from "./views/electronicErp/stockTakingCategorySku";
import ElectronicErpStockTakingCategorySkuBarcode from "./views/electronicErp/stockTakingCategorySkuBarcode";
import ElectronicErpInputDetail from "./views/electronicErp/InputDetail";
import ElectronicErpInputDetailHistory from "./views/electronicErp/scanHistory";
import ElectronicErpAllocation from "./views/electronicErp/allocation";
import ElectronicErpAllocationDetail from "./views/electronicErp/allocationDetail";
import ElectronicErpAllocationHostDetail from "./views/electronicErp/allocationHostDetail";
import ElectronicErpAllocationMaterialDetail from "./views/electronicErp/allocationMaterialDetail";

// import Header from './components/Header';
Vue.component("table-grid", TableGrid);
// Vue.component('v-header',Header);

Vue.mixin(checkPermission);
Vue.config.productionTip = false;

Vue.use(VueRouter);
const routes = [
  { path: "/login", component: Login },
  { path: "/sinochem/login", component: SinochemLogin },
  { path: "/sinochem/formLogin", component: SinochemFormLogin },
  { path: "/workflow/list", component: WorkFlowList },
  { path: "/wechat/bind", component: WechatBind },
  { path: "/serviceFee", component: ServiceFee },
  { path: "/receiptPlanDetail", component: ReceiptPlanDetail },
  { path: "/signUp", component: SignUp },
  { path: "/activityDetail", component: ActivityDetail },
  { path: "/pushSwitch", component: PushSwitch },
  { path: "/order/detail", component: OrderDetail },
  { path: "/tab", component: Tab },
  { path: "/customer/radar", component: Map },
  { path: "/customer", component: Customer },
  { path: "/SaleChanceDetails", component: SaleChanceDetails },
  { path: "/SaleChance", component: SaleChance },
  { path: "/EleContract", component: EleContract },
  { path: "/TabDetails", component: TabDetails },
  { path: "/ProjectDetails", component: ProjectDetails },
  { path: "/Project", component: Project },
  {
    path: "/qrCodeProjectDetails/:corpId/:projectId",
    component: QrCodeProjectDetails,
  },
  { path: "/thread", component: Thread },
  { path: "/threadPool", component: ThreadPool },
  { path: "/ThreadDetails", component: ThreadDetails },
  { path: "/Transfer", component: Transfer },
  { path: "/success", component: Success },
  { path: "/workflowPosition", component: WorkflowPosition },
  { path: "/forms/:id", component: Forms },
  { path: "/equipment", component: Equipment },
  { path: "/tg", component: TableGrid },
  { path: "/rad/index", component: Rad },
  { path: "/rad/input", component: Input },
  { path: "/rad/inputDetail", component: InputDetail },
  { path: "/rad/output", component: Output },
  { path: "/rad/outputDetails", component: OutputDetails },
  { path: "/rad/receiptOut", component: ReceiptOut },
  { path: "/rad/receiptOutDetails", component: ReceiptOutDetails },
  { path: "/rad/cancelStatus", component: CancelStatus },
  { path: "/rad/stocktaking", component: StockTaking },
  { path: "/customized/guohuanhuanbao/freight", component: Freight },
  {
    path: "/customized/guohuanhuanbao/freightDetail",
    component: FreightDetail,
  },
  { path: "/rad/stocktakingDetail", component: StockTakingDetail },
  { path: "/rad/stocktakingResult", component: StockTakingResult },
  { path: "/rad/scanningOutput", component: ScanningOutput },
  { path: "/rad/positionChange", component: PositionChange },
  { path: "/rad/dealerOrder", component: DealerOrder },
  { path: "/rad/radOrder", component: RadOrder },
  { path: "/rad/qualityInspection", component: QualityInspection },
  { path: "/rad/bomList", component: BomList },
  {path: "/rad/BomDetailList", component: BomDetailList},
  { path: "/rad/audit/radOrder", component: RadOrderAudit },
  { path: "/rad/orderDetail", component: RadOrderDetail },
  { path: "/rad/orderSku", component: OrderSku },
  { path: "/rad/radSku", component: RadSku },
  { path: "/rad/skuDetail", component: OrderSkuDetail },
  { path: "/rad/radDetail", component: RadSkuDetail },
  { path: "/rad/skuCart", component: SkuCart },
  { path: "/rad/radCart", component: RadCart },
  { path: "/rad/dealerRank", component: RadDealerRank },
  { path: "/rad/dealerRank/order", component: RadDealerRankOrder },
  { path: "/rad/dealerRank/orderDetail", component: RadRankOrderDetail },
  { path: "/rad/invIndex", component: InvIndex },
  { path: "/rad/skuInv", component: SkuInventory },
  { path: "/rad/partsInv", component: PartsInventory },
  { path: "/rad/searchDetail", component: SearchSkuDetail },
  { path: "/electronicErp/input", component: ElectronicErpInput },
  { path: "/electronicErp/inventoryBalance", component: ElectronicErpInventoryBalance },
  { path: "/electronicErp/inventoryBalance/detail/:skuCode/:warehouseId", component: ElectronicErpInventoryBalanceDetail },
  { path: "/electronicErp/stockTaking", component: ElectronicErpStockTaking },
  {
    path: "/electronicErp/stockTakingCategory/:uuid/:status",
    component: ElectronicErpStockTakingCategory,
  },
  {
    path: "/electronicErp/stockTakingCategorySku/:uuid/:categoryName/:status",
    component: ElectronicErpStockTakingCategorySku,
  },
  {
    path: "/electronicErp/stockTakingCategorySkuBarcode/:uuid/:isEnable/:sukName/:codeName/:stocktakingSkuNumber/:stocktakingNumber/:status",
    component: ElectronicErpStockTakingCategorySkuBarcode,
  },
  {
    path: "/electronicErp/inputDetail/:inputDataId",
    component: ElectronicErpInputDetail,
  },
  {
    path: "/electronicErp/scanHistory/:inputDataId",
    component: ElectronicErpInputDetailHistory,
  },
  { path: "/electronicErp/allocation", component: ElectronicErpAllocation },
  {
    path: "/electronicErp/allocationDetail/:allocationDataId",
    component: ElectronicErpAllocationDetail,
  },
  {
    path: "/electronicErp/allocationDetail/allocationHostDetail/:detailId",
    component: ElectronicErpAllocationHostDetail,
  },
  {
    path: "/electronicErp/allocationDetail/allocationMaterialDetail/:detailId",
    component: ElectronicErpAllocationMaterialDetail,
  },
  { path: "/order/summary", component: OrderSummary },
  { path: "/wechat/redAndTransfer", component: redAndTransfer },
  {
    path: "/app",
    component: App,
    children: [
      { path: "test", component: Test },
      {
        path: "forms/:workflowTemplateId/:id",
        component: Form,
        meta: { requireAuth: true },
      },
      { path: "form/:workflowTemplateId/:id/:defaultValue", component: Form },
      { path: "customer", component: Customer },
    ],
  },
  { path: "/marketActivity/ActivityList", component: ActivityList },
  { path: "/marketActivity/ActivityDetails", component: ActivityDetails },
  { path: "/marketActivity/MyCustomer", component: MyCustomer },
  { path: "/marketActivity/CustomerDetail", component: CustomerDetail },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const requireAuth = to.meta.requireAuth;
  if (requireAuth) {
    if (window.localStorage.getItem("login")) {
      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

new Vue({
  el: "#app",
  components: {
    [NavBar.name]: NavBar,
  },
  data: {},
  router,
  mounted() {
    if (this.$route.query.rememberMe) {
      let rememberMe = this.$route.query.rememberMe;
      Cookies.set("rememberMe", rememberMe, {
        expires: 360,
        domain: ".tysoft.com",
      });
    }
    userInfo.commit("init");
  },
  methods: {
    onClickBack() {
      alert("asd");
    },
  },
});
